import {Box, HStack, Text, ThemeColorPath} from 'platform/foundation';

interface MatrixLegendItemProps {
  label: string;
  backgroundColor: ThemeColorPath;
}

export function MatrixLegendItem(props: MatrixLegendItemProps) {
  return (
    <Box
      backgroundColor={props.backgroundColor}
      borderRadius="large"
      height={4}
      paddingHorizontal={1}
    >
      <HStack height="100%" align="center">
        <Text size="xxSmall">{props.label}</Text>
      </HStack>
    </Box>
  );
}
